import Dropdown from "../components/Dropdown";
import Footer from "../components/Footer";
import "../styles/FAQ.css";

export default function FAQ() {
  const faqItems = [
    {
      label: "Comment m'inscrire ?",
      texte:
        "Vous pouvez vous inscrire de deux façons : \n• par email (contact@lehyve.com), via notre rubrique contact \nou • en remplissant la fiche de renseignement. Nous vous répondrons rapidement pour confirmer votre inscription.",
    },
    {
      label: "Faut-il un niveau sportif particulier pour s'inscrire ?",
      texte:
        "Non. Aucun prérequis sportif n'est demandé. Il faut simplement être majeur, motivé et avoir un projet professionnel autour du coaching fitness.",
    },
    {
      label: "Est-ce que je peux financer via le CPF ?",
      texte:
        "Oui, selon votre situation. La formation est éligible CPF et OPCO. Nous vous accompagnons dans toutes les démarches.",
    },
    {
      label: "Le stage de 105h est-il obligatoire ?",
      texte:
        "Oui. Il fait partie du référentiel OC Sport et est obligatoire pour obtenir la certification.",
    },
    {
      label: "Le CQP est-il reconnu par l'État ?",
      texte:
        "Oui. Il est enregistré au RNCP niveau 4 et délivré par OC Sport.",
    },
    {
      label: "À l'issue de la formation, puis-je exercer légalement ?",
      texte:
        "Oui. Vous pourrez exercer comme coach fitness salarié ou indépendant partout en France.",
    },
    {
      label: "Que se passe-t-il si je rate un week-end de formation ?",
      texte:
        "Une absence peut être rattrapée selon les modalités définies avec votre formateur.",
    },
    {
      label: "Y a-t-il un paiement en plusieurs fois ?",
      texte:
        "Oui. Nous proposons plusieurs solutions de paiement selon votre situation.",
    },
    {
      label: "Je travaille à temps plein. Est-ce compatible ?",
      texte:
        "Oui. La formation est conçue pour être compatible avec une activité professionnelle.",
    },
  ];

  return (
    <div className="faq-page">

      <section className="faq-hero">

        <h1 className="faq-title-bg">FAQ</h1>

        <h2>QUESTIONS FRÉQUENTES</h2>

        <p className="faq-description">
          Si tu n'as pas trouvé la réponse ici,
          envoie-nous un message.
        </p>

        <button
          className="faq-contact-btn"
          onClick={() => (window.location.href = "/contact")}
        >
          Nous contacter
        </button>

      </section>

      <section className="faq-content">

        <div className="faq-list">
          {faqItems.map((item, index) => (
            <Dropdown
              key={index}
              label={item.label}
              texte={item.texte}
            />
          ))}
        </div>

      </section>

      <Footer backgroundColor="black" />

    </div>
  );
}